import { fromJS } from 'immutable';

export default {
    setMiddlewareConnectionState: (state, connectionState, mid, label) => {
        return state.setIn([mid], fromJS({ label, state: connectionState }));
    },
    setClientInterface: (state, clientInterface) => {
        return state.set('clientInterface', clientInterface);
    },
    setGroupId: (state, groupId) => {
        return state.set('groupId', groupId);
    },
    setConfig: (state, config) => {
        return state.merge(fromJS(config));
    }
};



// WEBPACK FOOTER //
// ./environments/fhe/core.js